export const PLAYER_ID = '003730';

const NAMES = [
  'Дмитрий',
  'Мура',
  'Темир',
  'Маржан',
  'Бахрам',
  'Жамиля',
  'Адильжан',
  'Азамат',
  'Абылайхан',
  'Айбек',
  'Алтай',
  'Бауыржан',
  'Жанибек',
  'Баш',
  'Ержан',
  'Жазира',
  'Адал',
  'Ерасыл',
  'Данияр',
  'Белла',
  'Жания',
  'Анастасия',
  'Арина',
  'Токжана',
  'Мухит',
  'Жанель',
  'Алмат',
  'Нурдаулет',
  'Арман',
];

function padId(value) {
  return String(value).padStart(6, '0');
}

function mulberry32(seed) {
  return () => {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function shuffleWith(list, random) {
  const result = [...list];
  for (let i = result.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export function buildBoard(period, energy = 0) {
  const players = NAMES.map((name, index) => ({
    name,
    id: padId(104821 + index * 173),
    me: false,
  }));

  const shuffled = shuffleWith(players, mulberry32(period === 'week' ? 20260817 : 20260818));
  if (period === 'month') {
    const leaderIndex = shuffled.findIndex((row) => row.name === 'Нурдаулет');
    if (leaderIndex > 0) {
      const [leader] = shuffled.splice(leaderIndex, 1);
      shuffled.unshift(leader);
    }
  }

  const others = shuffled.map((row, index) => ({
    ...row,
    score: period === 'week' ? 176400 - index * 4820 : 412800 - index * 9140,
  }));
  if (period === 'month' && others[0]?.name === 'Нурдаулет') {
    others[0].score = 431200;
  }

  const me = {
    name: 'Вы',
    id: PLAYER_ID,
    score: Math.max(0, Math.round(energy)),
    me: true,
  };

  return [...others, me]
    .sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      if (a.me) return -1;
      if (b.me) return 1;
      return 0;
    })
    .map((row, index) => ({ ...row, place: index + 1 }));
}

export function getMyPlace(period, energy = 0) {
  const me = buildBoard(period, energy).find((row) => row.me);
  return me ? me.place : NAMES.length + 1;
}
